<template>
    <Layout>
        <PageHeader :title="title" :items="items" />

        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <p class="text-muted font-13 mb-4"></p>
                        <div class="row mb-md-2">
                            <div class="col-sm-12 col-md-6">
                                <div id="tickets-table_length" class="dataTables_length">
                                    <label class="d-inline-flex align-items-left">
                                        Show&nbsp;
                                        <b-form-select
                                                v-model="perPage"
                                                size="sm"
                                                :options="pageOptions">
                                        </b-form-select>&nbsp;entries
                                    </label>

                                </div>
                            </div>
                            <!-- Search -->
                            <div class="col-sm-12 col-md-6">
                                <div id="tickets-table_filter" class="dataTables_filter text-md-right">
                                    <label class="d-inline-flex align-items-center">
                                        Search:
                                        <b-form-select
                                                v-model="filterKey"
                                                size="sm"
                                                :options="filterKeys">
                                        </b-form-select>
                                        <b-form-input
                                                v-model="filter"
                                                size="sm"
                                                type="search"
                                                placeholder="Search..."
                                                class="form-control form-control-sm ml-2">
                                        </b-form-input>
                                    </label>
                                </div>
                            </div>
                            <!-- End search -->
                        </div>
                        <!-- Table -->
                        <div class="table-responsive mb-0">
                            <b-table
                                    ref="productDataTable"
                                    :items="productData"
                                    :busy.sync="isBusy"
                                    :fields="fields"
                                    responsive="sm"
                                    :per-page="perPage"
                                    :current-page="currentPage"
                                    :sort-by.sync="sortBy"
                                    :sort-desc.sync="sortDesc"
                                    :filter="filter"
                                    :filter-included-fields="filterOn">

                                <template v-slot:cell(id)="row">
                                    <a href="javascript: void(0);"
                                       class="text-body font-weight-bold"
                                    >{{row.item.id}}</a>
                                </template>

                                <template v-slot:cell(action)="row">
                                    <b-button :id="row.item.id" variant="primary"
                                              type="button" class="btn btn-blue" @click="showModal(row.item)">
                                        <i class="mdi mdi-eye"></i>
                                    </b-button>
                                </template>

                            </b-table>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div class="dataTables_paginate paging_simple_numbers float-right">
                                    <ul class="pagination pagination-rounded mb-0">
                                        <!-- pagination -->
                                        <b-pagination
                                                v-model="currentPage"
                                                :total-rows="rows"
                                                :per-page="perPage"
                                                @input =" pageChange(currentPage);">
                                        </b-pagination>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <b-modal id="discount-modal"
                 ref="discountModal" size="lg" title="Discount in %" title-class="font-18">

            <div class="form-group">
                <input id="discountAmount"
                       v-model="discount" type="number" class="form-control"/>
            </div>
            <div class="form-group">
                <b-button id="submit-discount" variant="primary"
                          type="button" class="btn btn-blue" @click="submitDiscount" >
                    Submit
                </b-button>
            </div>
        </b-modal>
    </Layout>
</template>

<script>
  import appConfig from '@src/app.config'
  import Layout from '@layouts/main'
  import PageHeader from '@components/page-header'

  import { productMethods } from '@state/helpers'
  import { productFilters } from '@state/filters'


  /**
   * Advanced table component
   */
  export default {
    page: {
      title: 'Products',
      meta: [{ name: 'description', content: appConfig.description }],
    },
    components: { Layout, PageHeader },
    data() {
      return {
        products: [],
        title: 'Products',
        items: [
          {
            text: '99Gift',
            href: '/',
          },
          {
            text: 'Products',
            active: true,
          },
        ],
        isBusy: false,
        discount: null,
        remarkDetail: null,
        description: null,
        totalRows: 0,
        currentPage: 1,
        perPage: 10,
        pageOptions: [10, 25, 50, 100],
        filterKeys: productFilters,
        filterKey: null,
        filter: null,
        filterOn: [],
        sortBy: 'id',
        sortDesc: false,
        selectedRow: null,
        fields: [
          { key: 'id', label: 'Id', sortable: true },
          { key: 'sku', label: 'SKU', sortable: false },
          { key: 'name', label: 'Product', sortable: true },
          { key: 'discount', label: 'Discount', sortable: true },
          { key: 'action',  label: 'Action', sortable: false },
        ],
      }
    },
    computed: {
      /**
       * Total no. of records
       */
      rows() {
        return this.totalRows
      },
    },
    mounted() {

    },
    methods: {
      ...productMethods,

      /**
       * Search the table data with search input
       */
      async productData(context) {

        const { sortBy, sortDesc , perPage, currentPage } = context;

        this.currentPage = currentPage;
        this.rowsPerPage = perPage;

        this.isBusy = true

        try{

          const { success, message, data: { result } } = await this.fetchProducts({
            page: this.currentPage,
            rowsPerPage: this.perPage,
            sortBy,
            descending: sortDesc,
            value: this.status,
            filter: this.filter,
            filterKey: this.filterKey
          });

          if(!success) throw Error(message)

          this.totalRows = result.totalCount
          this.products =  result.data
        }
        catch (e){

          this.products = []
          this.appToast('Error', e.message || 'Error while operating', 'danger')
        }

        this.isBusy = false
        return this.products;
      },

      async pageChange(page){

        this.currentPage = page
      },

      async submitDiscount(){

        if(this.discount){

          try{

            const sku = this.selectedRow.sku;

            const { success, message } = await this.assignDiscount({
              sku,
              discount: parseFloat(this.discount)
            })

            if(!success) throw Error(message)

            this.appToast('Success', 'Discount assigned successfully!', 'success')
          }
          catch (e){
            this.appToast('Error', e.message || 'Error while operating', 'danger')
          }
        }
        else{

          this.appToast('Invalid discount', 'Error a valid discount value!', 'danger')
        }
      },

      showModal(data){
        this.selectedRow = data
        this.$refs.discountModal.show()
      },

      showToast(data){
        this.appToast('Order status', data.status)
      },
    },
  }
</script>